var _defs, _rect, _line, _line2, _line3, _line4, _line5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOpenPrivateDrive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    "data-name": "\\u56FE\\u5C42 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;stroke:#555;stroke-miterlimit:10;}.cls-2{stroke-linecap:round;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u753B\u677F 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3.5,
    y: 2.5,
    width: 17,
    height: 18,
    rx: 1.06
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 3.5,
    y1: 8.5,
    x2: 20.5,
    y2: 8.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 3.5,
    y1: 14.5,
    x2: 20.5,
    y2: 14.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 6.5,
    y1: 5.5,
    x2: 9.5,
    y2: 5.5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 6.5,
    y1: 11.5,
    x2: 9.5,
    y2: 11.5
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 6.5,
    y1: 17.5,
    x2: 9.5,
    y2: 17.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenPrivateDrive);
export default "data:image/svg+xml;base64,PHN2ZyBpZD0i5Zu+5bGCXzEiIGRhdGEtbmFtZT0i5Zu+5bGCIDEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDI0IDI0Ij48ZGVmcz48c3R5bGU+LmNscy0xLC5jbHMtMntmaWxsOm5vbmU7c3Ryb2tlOiM1NTU7c3Ryb2tlLW1pdGVybGltaXQ6MTA7fS5jbHMtMntzdHJva2UtbGluZWNhcDpyb3VuZDt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPueUu+advyAxPC90aXRsZT48cmVjdCBjbGFzcz0iY2xzLTEiIHg9IjMuNSIgeT0iMi41IiB3aWR0aD0iMTciIGhlaWdodD0iMTgiIHJ4PSIxLjA2Ii8+PGxpbmUgY2xhc3M9ImNscy0xIiB4MT0iMy41IiB5MT0iOC41IiB4Mj0iMjAuNSIgeTI9IjguNSIvPjxsaW5lIGNsYXNzPSJjbHMtMSIgeDE9IjMuNSIgeTE9IjE0LjUiIHgyPSIyMC41IiB5Mj0iMTQuNSIvPjxsaW5lIGNsYXNzPSJjbHMtMiIgeDE9IjYuNSIgeTE9IjUuNSIgeDI9IjkuNSIgeTI9IjUuNSIvPjxsaW5lIGNsYXNzPSJjbHMtMiIgeDE9IjYuNSIgeTE9IjExLjUiIHgyPSI5LjUiIHkyPSIxMS41Ii8+PGxpbmUgY2xhc3M9ImNscy0yIiB4MT0iNi41IiB5MT0iMTcuNSIgeDI9IjkuNSIgeTI9IjE3LjUiLz48L3N2Zz4=";
export { ForwardRef as ReactComponent };